module.exports = __webpack_public_path__ + "static/media/16.5a728be3.jpg";